export default "__VITE_ASSET__robj2P0F__"